const billingHistoryRowData = [
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },

  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },

  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },

  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
  {
    description: 'Invoice #23652122',
    date: '22-09-2023 05:12',
    amount: '$99.00',
    No_of_scan: '$99.00',
  },
];

export default billingHistoryRowData;
